import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from "prop-types";
import { sendContactForm } from '../../lib/ApiServices'
import DialogError from '../components/dialogError'
import {hideMessage, errorLoad} from '../../routers/messages'

import InputText from '../components/inputText'
import InputSelect from '../components/inputSelect'
import Checkbox from 'material-ui/Checkbox';


class sectionContact extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.state = {
      contact: {
      },
    };
  }

  handleClose = () => {
    this.props.hideMessage()
  };

  onChangeCaptcha = (value) => {
    console.log("Captcha value:", value);
  }

  checkEmail = (email = '', repeatEmail = '') => {

      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      let emailValidation = re.test(email)
      let repeatEmailValidation = re.test(email)

      if(!emailValidation || email !== repeatEmail){
        this.setState({
          error: true
        })
      }else{
        this.setState({
          error: false
        })
      }
  
      if(!repeatEmailValidation || repeatEmail !== email){
        this.setState({
          error: true
        })
      }else{
        this.setState({
          error: false
        })
      }
  }

  onChange = async (name, value, title, id) =>{
    await this.setState({contact: {...this.state.contact, [name]: value }})
    this.checkEmail(this.state.contact.email, this.state.contact.repeatEmail)
  }

  onSubmit = async () =>{
    const lang = this.context.router.route.location.pathname.split('/')[1]
    const response = await sendContactForm(this.state.contact)

    if(this.state.error){
      this.props.errorLoad("There're errors with your email!")
    }else if (!('sent' in response)) {
      this.props.errorLoad("There're errors in some fields!")
    } else {
      this.props.errorLoad("Thanks for your email.")

      // redirect home
      this.context.router.history.push(`/${lang}`)
    }
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    //const langPlace = languages[langUrl].constact
    const { prefixes, sectionContact } = languages[langUrl]
    const txt = sectionContact.form

    const arrayTypes = [
      { name: txt.queryTypes[0], value: 0 },
      { name: txt.queryTypes[1], value: 1 },
      { name: txt.queryTypes[2], value: 2 },
    ]

    const errors = {}
    const values = this.state.contact

    return (
      <div className="container-fluid">
          {this.props.messages ? <DialogError messages={this.props.messages} handleClose={this.handleClose} /> : ''}

          <section className="section-text row">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="h3 heavy">{sectionContact.customerServicePhone}</h2>
                  <p className="light">{sectionContact.customerServiceSchedule}</p>
                  <p className="heavy">+34 965 14 70 10</p>
                </div>

                <div className="col-md-12">
                  <div className='separating-line'><hr/></div>
                </div>

                <div className="col-md-12">
                  <h2 className="h3 heavy">{sectionContact.title}</h2>
                </div>

                <div className="col-md-12 margin-top-50"/>

                <div className='col-lg-12 col-md-12 col-sm-12'>
                  <div className='col-lg-4 col-md-4 col-sm-6 col-xs-4 no-padding'>
                    <InputText name='name' title={txt.fields.name} value={values} errors={errors} section='contact' onChange={this.onChange}/>
                  </div>
                  <div className='col-lg-4 col-md-4 col-sm-6 col-xs-4 no-padding'>
                    <InputText name='surname' title={txt.fields.surname} value={values} errors={errors} section='contact' onChange={this.onChange}/>
                  </div>
                  <div className='col-lg-4 col-md-4 col-sm-6 col-xs-4 no-padding'>
                    <InputText name='secondSurname' title={`${txt.fields.secondSurname} (${txt.optional})`} value={values} errors={errors} section='contact' onChange={this.onChange}/>
                  </div>
                </div>

                <div className='col-lg-12 col-md-12 col-sm-12'>
                  <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding'>
                    <InputText name='email' title={txt.fields.email} value={values} errors={errors} section='contact' onChange={this.onChange}/>
                  </div>
                  <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding'>
                    <InputText name='repeatEmail' title={txt.fields.repeatEmail} value={values} errors={errors} section='contact' onChange={this.onChange}/>
                  </div>
                </div>

                <div className='col-lg-12 col-md-12 col-sm-12'>
                  <div className='col-lg-4 col-md-4 col-sm-6 col-xs-6 no-padding'>
                    <InputSelect name='prefix' title={txt.fields.prefix} value={values} array={prefixes} errors={errors} section='contact' onChange={this.onChange}/>
                  </div>
                  <div className='col-lg-4 col-md-4 col-sm-6 col-xs-6 no-padding'>
                    <InputText name='phone' title={txt.fields.phone} value={values} errors={errors} section='contact' onChange={this.onChange}/>
                  </div>
                  <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12 no-padding'>
                    <InputSelect name='type' title={txt.fields.queryType} value={values} array={arrayTypes} errors={errors} section='contact' onChange={this.onChange}/>
                  </div>
                </div>
                <div className='col-lg-12 col-md-12 col-sm-12'>
                  <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding'>
                    <InputText name='message' title={txt.fields.queryMessage} value={values} lines={5} errors={errors} section='contact' onChange={this.onChange}/>
                  </div>
                </div>
                <div className='col-lg-12 col-md-12 col-sm-12 margin-top-15'>
                  <Checkbox
                    className="col-md-2"
                    labelStyle={{fontWeight: '400'}}
                    label={txt.fields.privacyCheck}
                    defaultValue={(false)? true: false}
                  />
                  <div className='general-button button-next col-md-2' onClick={this.onSubmit} style={{margin:0,float:'right'}}>
                    {txt.submit}<i className="fa fa-angle-right" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </section>

      </div>
    );
  }
}

export default connect(
  (state) => ({settings: state.settings}),
  {hideMessage, errorLoad}
)(sectionContact)



// WEBPACK FOOTER //
// ./src/shared/routes/routeContact/sectionContact.js